// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const BusinessIntelligenceIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M6.21 12H4.93C3.87 12 3 12.8 3 13.8v5.4c0 1 .87 1.8 1.93 1.8H6.2c1.07 0 1.93-.8 1.93-1.8v-5.4c0-1-.86-1.8-1.93-1.8m.65 7.2c0 .33-.3.6-.65.6H4.93c-.36 0-.64-.27-.64-.6v-5.4c0-.33.28-.6.64-.6H6.2c.36 0 .65.27.65.6zm5.78-10.8h-1.28c-1.07 0-1.93.8-1.93 1.8v9c0 1 .86 1.8 1.93 1.8h1.28c1.07 0 1.93-.8 1.93-1.8v-9c0-1-.86-1.8-1.93-1.8m.65 10.8c0 .33-.3.6-.65.6h-1.28c-.36 0-.65-.27-.65-.6v-9c0-.33.3-.6.65-.6h1.28c.36 0 .65.27.65.6zm5.78-15.6H17.8c-1.07 0-1.93.8-1.93 1.8v13.8c0 1 .86 1.8 1.93 1.8h1.28c1.06 0 1.93-.8 1.93-1.8V5.4c0-1-.87-1.8-1.93-1.8m.64 15.6c0 .33-.28.6-.64.6H17.8c-.36 0-.65-.27-.65-.6V5.4c0-.33.3-.6.65-.6h1.28c.36 0 .64.27.64.6z"
    />
  </svg>,
  "BusinessIntelligence",
);
export default BusinessIntelligenceIcon;
